import React, { type ReactElement, useEffect } from "react";

interface BackDropProps {
  children: ReactElement;
  className?: string;
  onClose?: () => void;
  preventScroll?: boolean;
}

const BackDrop: React.FC<BackDropProps> = ({
  children,
  className = "",
  onClose,
  preventScroll = true,
}) => {
  useEffect(() => {
    if (preventScroll) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [preventScroll]);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-primary-200/30 backdrop-blur-sm ${className}`}
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      {children}
    </div>
  );
};

export default BackDrop;
